
import {Observable } from 'rxjs';
import { IRouter } from '../core/models/router.model';
import { RouterDomainService } from '../core/services/router-domain.service';
import { RouterDetailComponent } from './router-detail.component';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { RouterServiceHttp } from '../core/services/router.servicehttp';
import { of as observableOf} from 'rxjs/observable/of'

 @Injectable()
 export class CanDeactivateRouterDetail1 implements CanDeactivate<RouterDetailComponent> {
  constructor(private routerService: RouterServiceHttp,
  private domain: RouterDomainService) {}

  canDeactivate(
    component: RouterDetailComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): Observable<boolean> {

    if (component && component.hasNotesChanges) {
      console.log('router-details.candeactivate notes:' + component.newNotes);
       return this.routerService.updateRouterNotes1(component.routerId, component.newNotes);
    } else {
      return observableOf(true);
    }
  }
}
